import { render } from "./ModalDashboard.vue?vue&type=template&id=4704d4e0&scoped=true"
import script from "./ModalDashboard.vue?vue&type=script&lang=js"
export * from "./ModalDashboard.vue?vue&type=script&lang=js"

import "./ModalDashboard.vue?vue&type=style&index=0&id=4704d4e0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4704d4e0"]])

export default __exports__